export default "__VITE_ASSET__73843098__"